import React from 'react';
import { EVENT_STATUS_VALUES, PAGES } from '../../../constants';
import TennisEventsScore from './TennisEventsScore';
import BookingContextMenu from '../BookingContextMenu';
import EventsContextMenu from '../EventsContextMenu';

const TennisEventsRow = ({
  event, eventDate, eventTime, bookUnbook,
  changePage,
}) => (
  <>
    <td>{event?.matchId}</td>
    <td>
      {eventDate}
      <span className="m-l-10">{eventTime}</span>
    </td>
    <td className="status" />
    <td>{event.playerOne || 'TBD'}</td>
    <td>{event.playerTwo || 'TBD'}</td>
    <td>
      <TennisEventsScore
        playerOneSetScore={event.playerOneSetScore}
        playerTwoSetScore={event.playerTwoSetScore}
        setsScoreHistory={event.setsScoreHistory}
      />
    </td>
    <td>{event.competition}</td>
    <td>{event.tournamentId}</td>
    <td>
      (
      {event.round}
      )
    </td>
    <td>
      <div className="context-menu">
        <div className="context-menu__list">
          {event.status === EVENT_STATUS_VALUES.FUTURE
          || event.status === EVENT_STATUS_VALUES.PRE_MATCH
            ? (
              <BookingContextMenu
                bookUnbook={bookUnbook.bind(this, event)}
                bookedFlag={event.bookedFlag}
              />
            )
            : (event.status === EVENT_STATUS_VALUES.IN_PROGRESS
              || event.status === EVENT_STATUS_VALUES.ENDED)
              ? (
                <EventsContextMenu
                  bookedFlag={event.bookedFlag}
                  changePage={changePage.bind(this, event)}
                  matchId={event.matchId}
                  oddsHistoryPage={PAGES.TENNIS_ODDS_HISTORY_STEP_1}
                  matchTimelinePage={PAGES.TENNIS_MATCH_TIMELINE}
                />
              ) : null}
        </div>
        <div className="context-menu__mask" />
      </div>
    </td>
  </>
);

export default TennisEventsRow;
